import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { debounce } from 'lodash';
import {
  mapStateToProps,
} from '../components/QueryFilterContainer';
import QueryFilterFieldEditCell from '../components/QueryFilterFieldEditCell';
import CohortFilterValue from './CohortFilterValue';
import { updateQueryFilterField } from '../actions';
import { fetchClauseCounts } from '../../profile/actions';
import { refreshCohortVisualisation } from '../../visualisations/actions';

const QueryFilterFieldTableCell = ({
  code,
  category,
  dictionary,
  fieldName,
  fieldLabel,
  clauseUUID,
  filterUUID,
  isEditing,
  exists,
  canRead,
  canEdit,
  updateField,
  fetchCounts,
  fetchVisualisation,
  queryUUID,
  saveErrors,
  fieldBeforeEdit,
}) => {
  const refreshCounts = useMemo(() => debounce(fetchCounts, 500), []);
  const refreshVisualisation = useMemo(() => debounce(fetchVisualisation, 700), []);

  const updateFilterField = (name) => {
    updateField(category, code, queryUUID, clauseUUID, filterUUID, name);
    refreshCounts(category, code, queryUUID, clauseUUID, true);
    refreshVisualisation(category, code, queryUUID);
  };

  if (!isEditing) {
    return (
      <CohortFilterValue
        category={category}
        code={code}
        value={fieldLabel}
        canRead={canRead}
        canEdit={canEdit}
        title={fieldLabel}
      />
    );
  }

  return (
    <QueryFilterFieldEditCell
      exists={exists}
      canRead={canRead}
      canEdit={canEdit}
      onChange={updateFilterField}
      fields={dictionary.fields}
      fieldName={fieldName}
      queryUUID={queryUUID}
      saveErrors={saveErrors}
      filterUUID={filterUUID}
      fieldBeforeEdit={fieldBeforeEdit}
    />
  );
};

export const mapDispatchToProps = {
  updateField: updateQueryFilterField,
  fetchCounts: fetchClauseCounts,
  fetchVisualisation: refreshCohortVisualisation,
};

export default connect(mapStateToProps, mapDispatchToProps)(QueryFilterFieldTableCell);
